module.exports = __webpack_public_path__ + "ad538a69b0e8615ed0419c4529344ffc.woff2";